// Dark mode trigger
var lsState = 0;
var ls;

function toggleLight() {
    lsState = (lsState + 1) % 3;
    updateLight();
}

function updateLight() {
    switch(lsState) {
        case 0:
            setLightAuto();
            updateLightSwitch('0%');
            break;
        case 1:
            setLightDark();
            updateLightSwitch('150%');
            break;
        case 2:
            setLightBright();
            updateLightSwitch('-150%');
            break;
    }

    localStorage.setItem('theme', JSON.stringify({
        lsState: lsState,
        updatedOn: Date.now()
    }));
}

function updateLightSwitch(pos) {
    if(ls) ls.style.transform = `translateY(${pos})`;
}

function setLightBright() {
    document.documentElement.classList.remove('dark');
}

function setLightDark() {
    document.documentElement.classList.add('dark');
}

function setLightAuto() {
    if(window.matchMedia('(prefers-color-scheme: dark)').matches) {
        setLightDark();
        return true;
    } else {
        setLightBright();
        return false;
    }
}

function resetLightPreference() {
    delete localStorage.theme;
}

// Set light mode
var lightPreferenceInit = false;
const h24 = 24 * 60 * 60 *1000;
if (window.matchMedia) {
    // Set saved light preference if available
    if(localStorage && localStorage.theme) {
        var theme = JSON.parse(localStorage.getItem('theme'));
        if((Date.now() - theme.updatedOn) <= h24)
        {
            lsState = theme.lsState;
            updateLight();
            lightPreferenceInit = true;
        } else {
            delete localStorage.theme;
            setLightAuto();
        }
    }
    // ...otherwise set to auto
    else {
        setLightAuto();
    }

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
        setLightAuto();
    });
}

// Finish initializing on load
window.addEventListener('load', function() {
    ls = document.querySelector('#lightswitch .lightswitch-button');

    if (window.matchMedia && !lightPreferenceInit) {
        setLightAuto() ? updateLightSwitch('150%') : updateLightSwitch('-150%');
    } else {
        updateLight();
    }

    document.documentElement.classList.add('dark-ready');
}, false);